<div class="d-flex">
  <div class="row setting-card-container mx-auto">
    <mat-card class="mat-elevation-z4 w-100">
      <mat-card-title>Stammdaten</mat-card-title>
      <mat-card-content>
        <mat-tab-group>
          <!--
              LANDER
          -->
          <mat-tab label="L&auml;nder">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-12 p-0">
                  <h2>L&auml;nder</h2>
                </div>
                <div class="col-sm-12 col-md-12 p-1">
                  <div class="p-4" style="display: flex; align-items: center; gap: 12px;">
                    <label style="font-size: 13px; white-space: nowrap;">Suche:</label>
                    <input type="text" placeholder="Filter..." (keyup)="applyFilter(dataSourceLander, $event)"
                      style="font-size: 13px; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; width: 200px;" />
                    <button mat-raised-button (click)="addNewLand()" color="primary">Neuanlage</button>
                  </div>
                  <table mat-table #tableLand [dataSource]="dataSourceLander" class="mat-elevation-z8">
                    <!-- id Column
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>ID</th>
                      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
                    -->

                    <!-- bezeichnung Column -->
                    <ng-container matColumnDef="bezeichnung">
                      <th mat-header-cell *matHeaderCellDef>Land</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.bezeichnung }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Land" [(ngModel)]="row.bezeichnung" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                      <td mat-cell *matCellDef="let row">
                        <button mat-button *ngIf="!row.isEditable" (click)="editItem('Land', row)" aria-label="Edit">
                          <mat-icon class="small-icon">edit</mat-icon> Edit
                        </button>
                        <button mat-button *ngIf="row.isEditable" (click)="saveItem('Land', row)" aria-label="Save">
                          <mat-icon class="small-icon">save</mat-icon> Save
                        </button>
                        <button mat-button *ngIf="row.isEditable" (click)="cancelEdit('Land', row)" aria-label="Cancel">
                          <mat-icon class="small-icon">close</mat-icon> Cancel
                        </button>
                        <button mat-button *ngIf="row.isEditable" (click)="removeItem('Land', row)" aria-label="Delete">
                          <mat-icon class="small-icon">delete</mat-icon> Delete
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayLander"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayLander" (dblclick)="editItem('Land', row)"></tr>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>

          <!--
              Bezirke
          -->
          <mat-tab label="Bezirke">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-12 p-0">
                  <h2>Bezirke</h2>
                </div>
                <div class="col-sm-12 col-md-12 p-1">
                  <div class="p-4" style="display: flex; align-items: center; gap: 12px;">
                    <label style="font-size: 13px; white-space: nowrap;">Suche:</label>
                    <input type="text" placeholder="Filter..." (keyup)="applyFilter(dataSourceBezirke, $event)"
                      style="font-size: 13px; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; width: 200px;" />
                    <button mat-raised-button (click)="addNewBezirk()" color="primary">Neuanlage</button>
                  </div>
                  <table mat-table #tableBezirk [dataSource]="dataSourceBezirke" class="mat-elevation-z8">
                    <!-- id Column
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>ID</th>
                      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
                    -->

                    <!-- Land Column -->
                    <ng-container matColumnDef="land">
                      <th mat-header-cell *matHeaderCellDef>Land</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.land }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Land" [(ngModel)]="row.land" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Bezirk Column -->
                    <ng-container matColumnDef="bezeichnung">
                      <th mat-header-cell *matHeaderCellDef>Bezirk</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.bezeichnung }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Bezirk" [(ngModel)]="row.bezeichnung" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                      <td mat-cell *matCellDef="let row">
                        <button mat-button *ngIf="!row.isEditable" (click)="editItem('Bezirk', row)" aria-label="Edit">
                          <mat-icon class="small-icon">edit</mat-icon> Edit
                        </button>
                        <button mat-button *ngIf="row.isEditable" (click)="saveItem('Bezirk', row)" aria-label="Save">
                          <mat-icon class="small-icon">save</mat-icon> Save
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="cancelEdit('Bezirk', row)"
                          aria-label="Cancel">
                          <mat-icon class="small-icon">close</mat-icon> Cancel
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="removeItem('Bezirk', row)"
                          aria-label="Delete">
                          <mat-icon class="small-icon">delete</mat-icon> Delete
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayBezirke"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayBezirke" (dblclick)="editItem('Bezirk', row)"></tr>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>

          <!--
              Strasse
          -->
          <mat-tab label="Strassen">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-12 p-0">
                  <h2>Strassen</h2>
                </div>
                <div class="col-sm-12 col-md-12 p-1">
                  <div class="p-4" style="display: flex; align-items: center; gap: 12px;">
                    <label style="font-size: 13px; white-space: nowrap;">Suche:</label>
                    <input type="text" placeholder="Filter..." (keyup)="applyFilter(dataSourceStrassen, $event)"
                      style="font-size: 13px; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; width: 200px;" />
                    <button mat-raised-button (click)="addNewStreet()" color="primary">Neuanlage</button>
                  </div>
                  <table mat-table #tableStreet [dataSource]="dataSourceStrassen" class="mat-elevation-z8">
                    <!-- id Column
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>ID</th>
                      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
                    -->

                    <!-- Strasse Column -->
                    <ng-container matColumnDef="bezeichnung">
                      <th mat-header-cell *matHeaderCellDef>Straße</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.bezeichnung }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Straße" [(ngModel)]="row.bezeichnung" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Tatortart Column -->
                    <ng-container matColumnDef="tatortart">
                      <th mat-header-cell *matHeaderCellDef>Tatortart</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.tatortart }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Tatortart" [(ngModel)]="row.tatortart" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                      <td mat-cell *matCellDef="let row">
                        <button mat-button *ngIf="!row.isEditable" (click)="editItem('Street', row)" aria-label="Edit">
                          <mat-icon class="small-icon">edit</mat-icon> Edit
                        </button>
                        <button mat-button *ngIf="row.isEditable" (click)="saveItem('Street', row)" aria-label="Save">
                          <mat-icon class="small-icon">save</mat-icon> Save
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="cancelEdit('Street', row)"
                          aria-label="Cancel">
                          <mat-icon class="small-icon">close</mat-icon> Cancel
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="removeItem('Street', row)"
                          aria-label="Delete">
                          <mat-icon class="small-icon">delete</mat-icon> Delete
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayStrassen"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayStrassen"
                      (dblclick)="editItem('Street', row)"></tr>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>

          <!--
              Farbe
          -->
          <mat-tab label="Farben">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-12 p-0">
                  <h2>Farben</h2>
                </div>
                <div class="col-sm-12 col-md-12 p-1">
                  <div class="p-4" style="display: flex; align-items: center; gap: 12px;">
                    <label style="font-size: 13px; white-space: nowrap;">Suche:</label>
                    <input type="text" placeholder="Filter..." (keyup)="applyFilter(dataSourceFarben, $event)"
                      style="font-size: 13px; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; width: 200px;" />
                    <button mat-raised-button (click)="addNewFarbe()" color="primary">Neuanlage</button>
                  </div>
                  <table mat-table #tableFarbe [dataSource]="dataSourceFarben" class="mat-elevation-z8">
                    <!-- id Column
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>ID</th>
                      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
                    -->

                    <!-- Farbe Column -->
                    <ng-container matColumnDef="bezeichnung">
                      <th mat-header-cell *matHeaderCellDef>Farbe</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.bezeichnung }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Farbe" [(ngModel)]="row.bezeichnung" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                      <td mat-cell *matCellDef="let row">
                        <button mat-button *ngIf="!row.isEditable" (click)="editItem('Farbe', row)" aria-label="Edit">
                          <mat-icon class="small-icon">edit</mat-icon> Edit
                        </button>
                        <button mat-button *ngIf="row.isEditable" (click)="saveItem('Farbe', row)" aria-label="Save">
                          <mat-icon class="small-icon">save</mat-icon> Save
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="cancelEdit('Farbe', row)"
                          aria-label="Cancel">
                          <mat-icon class="small-icon">close</mat-icon> Cancel
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="removeItem('Farbe', row)"
                          aria-label="Delete">
                          <mat-icon class="small-icon">delete</mat-icon> Delete
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayFarben"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayFarben" (dblclick)="editItem('Farbe', row)"></tr>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>

          <!--
              Hersteller
          -->
          <mat-tab label="Hersteller">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-12 p-0">
                  <h2>Hersteller</h2>
                </div>
                <div class="col-sm-12 col-md-12 p-1">
                  <div class="p-4" style="display: flex; align-items: center; gap: 12px;">
                    <label style="font-size: 13px; white-space: nowrap;">Suche:</label>
                    <input type="text" placeholder="Filter..." (keyup)="applyFilter(dataSourceHersteller, $event)"
                      style="font-size: 13px; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; width: 200px;" />
                    <button mat-raised-button (click)="addNewHersteller()" color="primary">Neuanlage</button>
                  </div>
                  <table mat-table #tableHersteller [dataSource]="dataSourceHersteller" class="mat-elevation-z8">
                    <!-- id Column
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>ID</th>
                      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
                    -->

                    <!-- Hersteller Column -->
                    <ng-container matColumnDef="bezeichnung">
                      <th mat-header-cell *matHeaderCellDef>Hersteller</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.bezeichnung }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Hersteller" [(ngModel)]="row.bezeichnung" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                      <td mat-cell *matCellDef="let row">
                        <button
                          mat-button
                          *ngIf="!row.isEditable"
                          (click)="editItem('Hersteller', row)"
                          aria-label="Edit">
                          <mat-icon class="small-icon">edit</mat-icon> Edit
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="saveItem('Hersteller', row)"
                          aria-label="Save">
                          <mat-icon class="small-icon">save</mat-icon> Save
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="cancelEdit('Hersteller', row)"
                          aria-label="Cancel">
                          <mat-icon class="small-icon">close</mat-icon> Cancel
                        </button>
                        <button
                          mat-button
                          *ngIf="row.isEditable"
                          (click)="removeItem('Hersteller', row)"
                          aria-label="Delete">
                          <mat-icon class="small-icon">delete</mat-icon> Delete
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayHersteller"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayHersteller"
                      (dblclick)="editItem('Hersteller', row)"></tr>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>

          <!--
              Tatbestand
          -->
          <mat-tab label="Tatbest&auml;nde">
            <div class="container-fluid p-1">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-12 p-0">
                  <h2>Tatbest&auml;nde</h2>
                </div>
                <div class="col-sm-12 col-md-12 p-1">
                  <div class="p-4" style="display: flex; align-items: center; gap: 12px;">
                    <label style="font-size: 13px; white-space: nowrap;">Suche:</label>
                    <input type="text" placeholder="Filter..." (keyup)="applyFilter(dataSourceTatbestande, $event)"
                      style="font-size: 13px; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; width: 200px;" />
                    <button mat-raised-button (click)="addNewTatbestand()" color="primary">Neuanlage</button>
                  </div>
                  <table mat-table #tableTatbestand [dataSource]="dataSourceTatbestande" class="mat-elevation-z8">
                    <!-- id Column
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>ID</th>
                      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
                    -->

                    <!-- VSTV Code Column -->
                    <ng-container matColumnDef="vstv_code">
                      <th mat-header-cell *matHeaderCellDef>VSTV Code</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable" class="text-bold">
                          <span style="font-weight: bold">{{ row.vstv_code }}</span>
                        </div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="VSTV Code" [(ngModel)]="row.vstv_code" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Paragraph Column -->
                    <ng-container matColumnDef="paragraph">
                      <th mat-header-cell *matHeaderCellDef>Paragraph</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.paragraph }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Paragraph" [(ngModel)]="row.paragraph" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- strafe Column -->
                    <ng-container matColumnDef="strafe">
                      <th mat-header-cell *matHeaderCellDef>Strafe</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.strafe }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Strafe" [(ngModel)]="row.strafe" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- short Column -->
                    <ng-container matColumnDef="short">
                      <th mat-header-cell *matHeaderCellDef>Kurzform</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.short }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="in Kurzform" [(ngModel)]="row.short" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- drucktext Column -->
                    <ng-container matColumnDef="drucktext">
                      <th mat-header-cell *matHeaderCellDef>Drucktext</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.drucktext }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Drucktext" [(ngModel)]="row.drucktext" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- reihung Column -->
                    <ng-container matColumnDef="reihung">
                      <th mat-header-cell *matHeaderCellDef>Reihung</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!row.isEditable">{{ row.reihung }}</div>
                        <mat-form-field *ngIf="row.isEditable" class="input-fullwith">
                          <input matInput placeholder="Reihung" [(ngModel)]="row.reihung" />
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="neuanlage">
                          <button
                            mat-button
                            *ngIf="row.isEditable"
                            (click)="saveItem('Tatbestand', row)"
                            aria-label="Save">
                            <mat-icon class="small-icon">save</mat-icon> Save
                          </button>
                          <button
                            mat-button
                            *ngIf="row.isEditable"
                            (click)="cancelEdit('Tatbestand', row)"
                            aria-label="Cancel">
                            <mat-icon class="small-icon">close</mat-icon> Cancel
                          </button>
                        </div>

                        <div *ngIf="!neuanlage">
                          <button mat-button (click)="removeItem('Tatbestand', row)" aria-label="Delete">
                            <mat-icon class="small-icon">delete</mat-icon> Delete
                          </button>
                          <button mat-button (click)="editItem('Tatbestand', row)" aria-label="Edit">
                            <mat-icon class="small-icon">edit</mat-icon> Edit
                          </button>
                        </div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayTatbestande"></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayTatbestande"
                      (dblclick)="editItem('Tatbestand', row)"></tr>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>

          <!-- WHITELIST TAB -->
          <mat-tab label="Whitelist">
            <div class="container-fluid p-3">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>Kennzeichen Whitelist</h2>
                  <small>Freigestellte Kennzeichen werden bei Transfer, Überfällig-Markierung und VSTV-Export automatisch storniert. Das Kennzeichen wird nur als Hash gespeichert — das Original verlässt nie den Browser.</small>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <!-- Add form -->
                  <div class="mt-3 p-3" style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px;">
                    <div style="display: flex; gap: 10px; align-items: flex-end; flex-wrap: wrap;">
                      <div style="flex: 1; min-width: 200px;">
                        <label class="bold" style="font-size: 12px; display: block; margin-bottom: 4px;">Kennzeichen</label>
                        <div style="position: relative;">
                          <input
                            type="text"
                            [(ngModel)]="whitelistPlate"
                            (ngModelChange)="onPlateInput()"
                            (input)="whitelistPlate = $any($event.target).value.toUpperCase()"
                            maxlength="14"
                            class="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            [class.border-red-500]="whitelistPlateError"
                            [class.border-green-500]="whitelistPlateValid && !whitelistPlateError"
                            [class.border-gray-300]="!whitelistPlateError && !whitelistPlateValid"
                            style="text-transform: uppercase; padding-right: 32px;"
                            placeholder="z.B. W 12345X" />
                          <span *ngIf="whitelistPlateValid && !whitelistPlateError"
                            style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); color: #16a34a; font-size: 18px;">&#10003;</span>
                          <span *ngIf="whitelistPlateError"
                            style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); color: #dc2626; font-size: 18px;">&#10007;</span>
                        </div>
                        <small *ngIf="whitelistPlateError" style="color: #dc2626; font-size: 11px;">{{ whitelistPlateError }}</small>
                        <small *ngIf="whitelistPlateValid && !whitelistPlateError" style="color: #16a34a; font-size: 11px;">Gültiges Kennzeichen</small>
                      </div>
                      <div style="flex: 2; min-width: 200px;">
                        <label class="bold" style="font-size: 12px; display: block; margin-bottom: 4px;">Grund (optional)</label>
                        <input
                          type="text"
                          [(ngModel)]="whitelistReason"
                          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                          placeholder="z.B. Firmenfahrzeug" />
                      </div>
                      <div>
                        <button mat-raised-button color="primary" (click)="addWhitelistEntry()">Hinzufügen</button>
                      </div>
                    </div>
                  </div>

                  <!-- Toggle delete form -->
                  <div class="mt-2">
                    <button mat-stroked-button color="warn" (click)="toggleDeleteForm()" style="font-size: 12px;">
                      <mat-icon class="small-icon">{{ whitelistShowDeleteForm ? 'close' : 'delete_outline' }}</mat-icon>
                      {{ whitelistShowDeleteForm ? 'Abbrechen' : 'Kennzeichen entfernen' }}
                    </button>
                  </div>

                  <!-- Delete by plate form (shown on toggle) -->
                  <div *ngIf="whitelistShowDeleteForm" class="whitelist-delete-form mt-3 p-3" style="background: #fff5f5; border: 1px solid #fecaca; border-radius: 8px;">
                    <div style="display: flex; gap: 10px; align-items: flex-end; flex-wrap: wrap;">
                      <div style="flex: 1; min-width: 200px;">
                        <label class="bold" style="font-size: 12px; display: block; margin-bottom: 4px;">Kennzeichen das entfernt werden soll</label>
                        <div style="position: relative;">
                          <input
                            type="text"
                            [(ngModel)]="whitelistDeletePlate"
                            (ngModelChange)="onDeletePlateInput()"
                            (input)="whitelistDeletePlate = $any($event.target).value.toUpperCase()"
                            maxlength="14"
                            class="bg-white border text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5"
                            [class.border-red-500]="whitelistDeletePlateError"
                            [class.border-green-500]="whitelistDeletePlateValid && !whitelistDeletePlateError"
                            [class.border-gray-300]="!whitelistDeletePlateError && !whitelistDeletePlateValid"
                            style="text-transform: uppercase; padding-right: 32px;"
                            placeholder="z.B. W 12345X" />
                          <span *ngIf="whitelistDeletePlateValid && !whitelistDeletePlateError"
                            style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); color: #16a34a; font-size: 18px;">&#10003;</span>
                          <span *ngIf="whitelistDeletePlateError"
                            style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); color: #dc2626; font-size: 18px;">&#10007;</span>
                        </div>
                        <small *ngIf="whitelistDeletePlateError" style="color: #dc2626; font-size: 11px;">{{ whitelistDeletePlateError }}</small>
                        <small *ngIf="whitelistDeletePlateValid && !whitelistDeletePlateError" style="color: #16a34a; font-size: 11px;">Gültiges Kennzeichen</small>
                      </div>
                      <div>
                        <button mat-raised-button color="warn" (click)="deleteWhitelistEntryByPlate()" [disabled]="!whitelistDeletePlateValid">Entfernen</button>
                      </div>
                    </div>
                  </div>

                  <!-- List -->
                  <div *ngIf="whitelistLoading" class="mt-4"><p>Laden...</p></div>

                  <table *ngIf="!whitelistLoading && whitelistEntries.length > 0" class="table table-striped table-sm mt-4" style="font-size: 12px;">
                    <thead>
                      <tr>
                        <th class="bold">Hash</th>
                        <th class="bold">Grund</th>
                        <th class="bold">Erstellt von</th>
                        <th class="bold">Erstellt am</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let entry of whitelistEntries">
                        <td style="font-family: monospace; font-size: 11px;" [title]="entry.plate_hash">{{ truncateHash(entry.plate_hash) }}</td>
                        <td>{{ entry.reason || '–' }}</td>
                        <td>{{ entry.created_by }}</td>
                        <td>{{ entry.created_at }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div *ngIf="!whitelistLoading && whitelistEntries.length === 0" class="mt-4">
                    <p style="color: #6b7280;">Keine Einträge in der Whitelist.</p>
                  </div>

                  <button mat-raised-button class="mt-2" (click)="loadWhitelist()" style="background-color: #6b7280; color: #fff;">
                    Aktualisieren
                  </button>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>
